<template>
  <BaseDialog
    :title="$t('coaching.assessment.editCoachees')"
    :is-open="isOpen"
    type="responsive"
    :align-dismiss-button-right="true"
    @close="closeDialog"
  >
    <SurveyMembersForm
      v-model:feedback-sender-ids="formData.coacheeIds"
      :label="$t('coaching.addCoachees')"
      :members-error="errors.get('coacheeIds')"
      :show-select-all-button="true"
      member-filter="coachees"
    />
    <template #confirm>
      <BaseTextButton color="filled" :disabled="isSaving" @click="saveAssessmentEdits">
        {{ $t('common.save') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" :disabled="isSaving" @click="closeDialog">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import SurveyMembersForm from '@/modules/start-assessment/components/SurveyMembersForm.vue'
  import type { AssessmentDetail } from './use-assessment'
  import { useEditAssessment } from './use-edit-assessment'

  interface Props {
    isOpen: boolean
    assessment: AssessmentDetail
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close-dialog'): void
    (e: 'assessment-updated'): void
  }>()

  const closeDialog = () => {
    emit('close-dialog')
    resetForm()
  }

  watch(
    () => props.isOpen,
    () => {
      resetForm()
    },
  )

  const { saveAssessmentEdits, resetForm, formData, errors, isSaving } = useEditAssessment(
    computed(() => props.assessment),
    () => {
      emit('assessment-updated')
      closeDialog()
    },
  )
</script>
